import {MILLISECONDS_IN_SECOND, SECONDS_IN_MINUTE} from "../constants";

const errorMessageCloseBind = (sectionName, errorUUID) => {
  const errorCloseClick = () => {
    onErrorCloseClick(sectionName, errorUUID);
  };

  $(`#${sectionName} .section_edit`).find('.error-close').click(errorCloseClick);
};

const onErrorCloseClick = (sectionName, errorUUID) => {
  $(`#${sectionName} .section_edit .error-message--with-close`).hide();
  $(`#${sectionName} .section_view .error-message--with-close`).hide();
  $.cookie(`${sectionName}-vo-error-closed`, errorUUID, {expires: 365, secure: true});
};

const validateAutoStop = (dateInput, timeInput) => {
  const dateInputValue = dateInput.querySelector('input').value;
  const timeInputValue = timeInput.querySelector('input').value;

  let autostopValue = null;

  if (dateInputValue && timeInputValue) {
    const currentDateTime = new Date();
    const autoStopDateTime = new Date(dateInputValue + ' ' + timeInputValue);
    let hasError = false;
    const diffMinutes = (autoStopDateTime - currentDateTime) / 1000 / 60;
    const diffHours = diffMinutes / 60;
    if (autoStopDateTime.isToday() && diffHours < 1) {
      timeInput.status = "error";
      timeInput.message = _flow_recovery_failover_autostop_error_one_hour_in_the_future;
      hasError = true;
    } else {
      if (diffHours < 0) {
        dateInput.status = "error";
        dateInput.message = _flow_recovery_failover_autostop_error_future_date;
        hasError = true;
      } else if (diffHours < 1) {
        timeInput.status = "error";
        timeInput.message = _flow_recovery_failover_autostop_error_one_hour_in_the_future;
        hasError = true;
      } else if (diffMinutes > 60 * 24 * 365) {
        dateInput.status = "error";
        dateInput.message = _flow_recovery_failover_autostop_error_exceed_maximum;
        hasError = true;
      }
    }
    if (!hasError) {
      autostopValue = autoStopDateTime;
    }
  }
  return autostopValue;
}

const convertAutoStopValueToMinutes = (value) => {
  return value === undefined ? null : Math.round((value - new Date()) / MILLISECONDS_IN_SECOND / SECONDS_IN_MINUTE);
}

export {errorMessageCloseBind, onErrorCloseClick, validateAutoStop, convertAutoStopValueToMinutes};
